import React from "react";
import LegalDocument from "@/components/LegalDocument";

export default function TermsOfService() {
  return (
    <LegalDocument
      titleKey="termsTitle"
      docKey="terms"
      testId="legal-terms-page"
    />
  );
}
